import { positionConstants } from '../constant/position.constants';
import { position } from '../services/position.service';
import CONSTANT from '../constant/constant';
import functionCommon from "../common/function";

const _errorCode = CONSTANT.errorCode;

export const getPositionList = (data) => {
    if (functionCommon.checkRequestApiTime()) {
        return functionCommon.logout();
    }    
    return dispatch => {
        position.list(data)
            
            .then(
                res => {
                    if(!res) return;
                    switch (res['http_code']) {
                        case _errorCode.APISuccess:
                            dispatch(success(res.result));
                            break;

                        case _errorCode.TOKENExpired:
                            functionCommon.logout()
                            break;
                        
                        case _errorCode.APIInvalids:
                            functionCommon.logout();
                            break;
                        
                        case _errorCode.ClientNotPermission:
                            functionCommon.logout();
                            break;

                        default:
                            window.location = '/error/404';
                            break;
                    }
                   
                }
            );
    };

    function success(positionList) { 
        return { type: positionConstants.GET_SUCCESS, positionList }; 
    }
}

export const addPosition = (data) => {
    if (functionCommon.checkRequestApiTime()) {
        return functionCommon.logout();
    }    
    return dispatch => {
        position.add(data)
            .then(
                res => {
                    if(!res) return;
                    switch (res['http_code']) {
                        case _errorCode.APISuccess:
                                dispatch(success('004'));
                            break;

                        case _errorCode.TOKENExpired:
                            functionCommon.logout()
                            break;

                        case _errorCode.APIInvalids:
                            functionCommon.logout();
                            break;
    
                        case _errorCode.DBCanNotConnect:
                            window.location = '/error/404';
                            break;

                        default:
                            dispatch(failure(res['error_code']));
                            break;
                    }
                   
                }
            );
    };

    function success(code) { 
        return { type: positionConstants.ADD_SUCCESS, code}; 
    }

    function failure(error) {
        return { type: positionConstants.ADD_FAILURE, error }; 
    }
}

export const deletePosition = (data) => {
    if (functionCommon.checkRequestApiTime()) {
        return functionCommon.logout();
    }    
    return dispatch => {
        position.delete(data)
            .then(
                res => {
                    if(!res) return;
                    switch (res['http_code']) {
                        case _errorCode.APISuccess:
                            dispatch(success('004'));
                            break;

                        case _errorCode.TOKENExpired:
                            functionCommon.logout()
                            break;

                        case _errorCode.APIInvalids:
                            functionCommon.logout();
                            break;
    
                        case _errorCode.DBCanNotConnect:
                            window.location = '/error/404';
                            break;

                        default:
                            dispatch(failure(res['error_code']));
                            break;
                    }
                   
                }
            );
    };

    function success(code) { 
        return { type: positionConstants.DELETE_SUCCESS, code}; 
    }

    function failure(error) {
        return { type: positionConstants.DELETE_FAILURE, error }; 
    }
}

export const updatePosition = (data) => {
    if (functionCommon.checkRequestApiTime()) {
        return functionCommon.logout();
    }    
    return dispatch => {
        position.update(data)
            .then(
                res => {
                    if(!res) return;
                    switch (res['http_code']) {
                        case _errorCode.APIUpdatedSuccess:
                            dispatch(success('004'));
                            break;

                        case _errorCode.TOKENExpired:
                            functionCommon.logout()
                            break;
                    
                        case _errorCode.APIInvalids:
                            functionCommon.logout();
                            break;
    
                        case _errorCode.DBCanNotConnect:
                            window.location = '/error/404';
                            break;

                        default:
                            dispatch(failure(res['error_code']));
                            break;
                    }
                   
                }
            );
    };

    function success(code) { 
        return { type: positionConstants.UPDATE_SUCCESS, code}; 
    }

    function failure(error) {
        return { type: positionConstants.UPDATE_FAILURE, error }; 
    }
}